import React, { useState } from "react";
// import { KeyboardArrowDown } from '@mui/icons-material';
import './SortDropdown.css';

const SortDropdown = ({ sortBy, onSortChange }) => {
  const [open, setOpen] = useState(false);

  const sortOptions = [
    { value: "featured", label: "Featured" },
    { value: "bestSelling", label: "Best selling" },
    { value: "alphaAZ", label: "Alphabetically, A-Z" },
    { value: "alphaZA", label: "Alphabetically, Z-A" },
    { value: "priceLowHigh", label: "Price, low to high" },
    { value: "priceHighLow", label: "Price, high to low" },
    { value: "dateOldNew", label: "Date, old to new" },
    { value: "dateNewOld", label: "Date, new to old" },
  ];

  const handleSelect = (value) => {
    onSortChange(value);
    setOpen(false);
  };
  return (
    <div className="sort-dropdown">
      <span className="sort-trigger" onClick={() => setOpen(!open)}>
        <span style={{  opacity: .7}}>Sort by:</span>  {sortOptions.find(opt => opt.value === sortBy)?.label}
        {/* <KeyboardArrowDown /> */}
      </span>
      {open && (
        <>
          <div className="sort-overlay" onClick={() => setOpen(false)} />
          <div className="sort-menu">
            {sortOptions.map(option => (
              <div
                key={option.value}
                className={`sort-option ${sortBy === option.value ? 'active' : ''}`}
                onClick={() => handleSelect(option.value)}
              >
                {option.label}
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default SortDropdown;